var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.mode == "readtable"
      ? _c(
          "div",
          _vm._l(_vm.customFields, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "mb-3 white-bkg b-1 br" },
              [
                _c(
                  "header",
                  {
                    staticClass: "flex-level jc-space bb-1 cpointer",
                    on: {
                      click: function($event) {
                        item.openByDefault = !item.openByDefault
                      }
                    }
                  },
                  [
                    _c("h3", { staticClass: "m-0 p-3 flex-level" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            item.name
                              ? item.name
                              : _vm.$l10n.__("Groupe par défaut")
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      { staticClass: "gray-100 pointer flex-right p-3" },
                      [
                        _c("i", {
                          staticClass: "icon-arrow-back dinlineb gray-60",
                          class: item.openByDefault
                            ? "rotated-270"
                            : "rotated-90"
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                item.openByDefault
                  ? _c(
                      "table",
                      {
                        staticClass: "wp-10 table no-border with-vertical-line"
                      },
                      [
                        _c(
                          "tbody",
                          _vm._l(item.fields, function(customField, cfIndex) {
                            return _c("tr", { key: cfIndex }, [
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "flex-level" },
                                  [
                                    _c("div", { staticClass: "p-2" }, [
                                      _vm._v(_vm._s(customField.name))
                                    ]),
                                    _vm._v(" "),
                                    customField.description.length
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "flex-right mr-2",
                                            attrs: {
                                              effect: "dark",
                                              "popper-class":
                                                "customfields-tool-tip",
                                              placement: "bottom-start"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "content",
                                                  fn: function() {
                                                    return [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            customField.description
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass: "icon-help"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "relative customfields-value" },
                                [
                                  _c("CustomfieldHistory", {
                                    class: {
                                      "history-top-pos": _vm.hasHistoryTopPos(
                                        customField
                                      )
                                    },
                                    attrs: {
                                      cfid: customField.id,
                                      cfname: customField.name,
                                      emitEditSuccess: _vm.emitEditSuccess
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("cf-" + customField.type, {
                                    key:
                                      customField.id +
                                      "::" +
                                      _vm.customFieldValues.some(function(ref) {
                                        var customFieldId = ref.customFieldId

                                        return customFieldId === customField.id
                                      }),
                                    tag: "component",
                                    attrs: {
                                      notStoredValue: !_vm.customFieldValues.some(
                                        function(ref) {
                                          var customFieldId = ref.customFieldId

                                          return (
                                            customFieldId === customField.id
                                          )
                                        }
                                      ),
                                      mode: "read",
                                      prop: customField,
                                      placeholder: customField.defaultValue,
                                      value: _vm.correspondingData(customField),
                                      context: _vm.context
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "customfieldForm",
                attrs: {
                  "label-position": "top",
                  "inline-message": true,
                  "label-width": "120px"
                }
              },
              _vm._l(_vm.customFields, function(customFieldGroup, index) {
                return _c("div", { key: index }, [
                  _c("h4", [
                    _c(
                      "a",
                      {
                        staticClass: "gray-100 pointer",
                        on: {
                          click: function($event) {
                            customFieldGroup.openByDefault = !customFieldGroup.openByDefault
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              customFieldGroup.name
                                ? customFieldGroup.name
                                : _vm.$l10n.__("Groupe par défaut")
                            ) +
                            "\n                        "
                        ),
                        _c("i", {
                          staticClass:
                            "icon-arrow-back dinlineb gray-60 fright",
                          class: customFieldGroup.openByDefault
                            ? "rotated-270"
                            : "rotated-90"
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: customFieldGroup.openByDefault,
                          expression: "customFieldGroup.openByDefault"
                        }
                      ]
                    },
                    _vm._l(customFieldGroup.fields, function(
                      customField,
                      index
                    ) {
                      return _c(
                        "el-form-item",
                        {
                          key: index,
                          attrs: {
                            id: customField.id,
                            prop: _vm.referenceCf({
                              customFieldId: customField.id,
                              type: customField.type
                            }),
                            error: _vm.errors.get(
                              _vm.referenceCf({
                                customFieldId: customField.id,
                                type: customField.type
                              })
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "flex-level" },
                                      [
                                        customField.description.length
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  effect: "dark",
                                                  "popper-class": "w-4",
                                                  placement: "bottom"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "content",
                                                      fn: function() {
                                                        return [
                                                          _c("div", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                customField.description
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass: "icon-help"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.labelCf(customField)) +
                                              "\n                                "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("cf-" + customField.type, {
                            tag: "component",
                            attrs: {
                              mode: _vm.mode,
                              prop: customField,
                              placeholder: customField.defaultValue,
                              value: _vm.correspondingData(customField),
                              context: _vm.context
                            },
                            on: {
                              input: _vm.updateValue,
                              remove: _vm.removeValue,
                              error: _vm.errorValue
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ])
              }),
              0
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }